import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const languageFromLocalStorage = localStorage.getItem('preferenceLanguage');

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt',
    lng: languageFromLocalStorage || undefined,  // Use the language from localStorage if available
    debug: true,
    ns: ['homenova, chooseproject, choosefile, projectpreview, myprojects, myaccount, navbar, footer, homepage, features, faq, plans, login, register '],  // List of namespaces
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },

  });

export default i18n;
